<div class="vacation-header-container">
    <div class="vacation-stats-table">
        <table>
            <thead>
            <tr>
                <th></th>
                <th>Carryover</th>
                <th>Accrued</th>
                <th>Used</th>
                <th>Remaining</th>
            </tr>
            </thead>
            <tbody>
            <tr class="sick-row">
                <td class="type-label">Sick Time Off</td>
                <td>{{ vacationStats?.carryoverSickDays }}</td>
                <td>{{ vacationStats?.accruedSickDays }}</td>
                <td>{{ vacationStats?.usedSickDaysApproved }}</td>
                <td>{{ vacationStats?.availableSickDays }}</td>
            </tr>
            <tr class="vacation-row">
                <td class="type-label">Vacation</td>
                <td>{{ vacationStats?.carryoverVacationDays }}</td>
                <td>{{ vacationStats?.accruedVacationDays }}</td>
                <td>{{ vacationStats?.usedVacationDaysApproved }}</td>
                <td>{{ vacationStats?.availableVacationDays }}</td>
            </tr>
            <tr class="unpaid-row">
                <td class="type-label">Unpaid PTO</td>
                <td>--</td>
                <td>--</td>
                <td>{{ vacationStats?.usedUnpaidVacationDaysTotal }}</td>
                <td>--</td>
            </tr>
            </tbody>
        </table>
        <div class="stats-note" *ngIf="vacationStats">{{ vacationStats?.workedHrs }} hours worked.</div>
        <div class="add-request-container" *ngIf="currentUser.adminRole || !currentUser.isContractor">
            <button mat-button (click)="openRequestDialog()" class="add-request-btn">
                <mat-icon>add</mat-icon>
                <span>Request PTO</span>
            </button>
        </div>
    </div>
</div>
<ng-container *ngIf="!sheetLoading">
    <div class="date-blocks" *ngIf="timeCards.length > 0">
        <div class="date-block" *ngFor="let timeCard of timeCards"
             [ngClass]="{'can-be-clicked': !timeCard.approved, 'approved-day': timeCard.approved, 'rejected-day': timeCard.rejected, 'late-vacation': checkLate(timeCard),
                     'sick-type': timeCard.type === 'SICK_HOURS', 'vacation-type': timeCard.type === 'VACATION', 'unpaid-type': timeCard.type === 'UNPAID_VACATION'}">
            <div class="date-title" (click)="openSheetDialog(timeCard)">
                <span class="vacation-type-indicator"
                      [ngClass]="getVacationTypeClass(timeCard.type)">{{ getVacationTypeLabel(timeCard.type) }}</span>
                <span class="date-span">{{ timeCard.startTime | date:'EEE, MMM d' }}</span>
                <span class="approved-span label-spanchik" *ngIf="timeCard.approved">Approved</span>
                <span class="in-request-span label-spanchik"
                      *ngIf="!timeCard.approved && !timeCard.rejected">In-Request</span>
                <span class="in-request-span label-spanchik" *ngIf="timeCard.rejected">Rejected

        <i #infoIconHover class="pi pi-info-circle vacation-reject-info-icon"
           pTooltip="{{timeCard.rejectReason ? timeCard.rejectReason : 'null'}}"
           tooltipStyleClass="vacation-reject-info-panel"
           tooltipPosition="bottom"></i>
        </span>
            </div>
        </div>
    </div>

    <div class="date-blocks no-cards" *ngIf="timeCards.length === 0">
        No Vacations Requested
    </div>

</ng-container>

<div class="spinner-box" *ngIf="sheetLoading">
    <mat-spinner class="spinner"></mat-spinner>
</div>
